module.exports = __webpack_public_path__ + "static/media/Weatherapp.4b3d2cec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Weatherapp.png
// module id = 39
// module chunks = 1